module.exports = __webpack_public_path__ + "img/quick-play-close.d358e06f.svg";